import(/* webpackMode: "eager", webpackExports: ["AnimatedLoading"] */ "/workspace/src/components/ui/animated-title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PressDetailClient"] */ "/workspace/src/components/ui/press/press-detail-client.tsx");
